namespace $ {
	export class $gen_app extends $mol_page {
		
		/**
		 * ```tree
		 * title \🧬Gen v0.1. Игра ~ Герои, PoE, моды
		 * ```
		 */
		title() {
			return "🧬Gen v0.1. Игра ~ Герои, PoE, моды"
		}
		
		/**
		 * ```tree
		 * user? $gen_engine_user
		 * ```
		 */
		@ $mol_mem
		user(next?: any) {
			if ( next !== undefined ) return next as never
			const obj = new this.$.$gen_engine_user()
			
			return obj
		}
		
		/**
		 * ```tree
		 * tools /
		 * 	<= Debug_user
		 * 	<= Clear_storage
		 * 	<= Telegram
		 * 	<= Sources
		 * ```
		 */
		tools() {
			return [
				this.Debug_user(),
				this.Clear_storage(),
				this.Telegram(),
				this.Sources()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * body / <= Pages
		 * ```
		 */
		body() {
			return [
				this.Pages()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * debug_user \
		 * ```
		 */
		debug_user() {
			return ""
		}
		
		/**
		 * ```tree
		 * Debug_user $mol_paragraph title <= debug_user
		 * ```
		 */
		@ $mol_mem
		Debug_user() {
			const obj = new this.$.$mol_paragraph()
			
			obj.title = () => this.debug_user()
			
			return obj
		}
		
		/**
		 * ```tree
		 * clear_storage? null
		 * ```
		 */
		@ $mol_mem
		clear_storage(next?: any) {
			if ( next !== undefined ) return next as never
			return null as any
		}
		
		/**
		 * ```tree
		 * Clear_storage $mol_button_minor
		 * 	title \♻️
		 * 	click? <=> clear_storage?
		 * ```
		 */
		@ $mol_mem
		Clear_storage() {
			const obj = new this.$.$mol_button_minor()
			
			obj.title = () => "♻️"
			obj.click = (next?: any) => this.clear_storage(next)
			
			return obj
		}
		
		/**
		 * ```tree
		 * Telegram_icon $mol_icon_telegram
		 * ```
		 */
		@ $mol_mem
		Telegram_icon() {
			const obj = new this.$.$mol_icon_telegram()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Telegram $mol_link_source
		 * 	Icon <= Telegram_icon
		 * 	uri \https://github.com/Lyumih/gen
		 * ```
		 */
		@ $mol_mem
		Telegram() {
			const obj = new this.$.$mol_link_source()
			
			obj.Icon = () => this.Telegram_icon()
			obj.uri = () => "https://github.com/Lyumih/gen"
			
			return obj
		}
		
		/**
		 * ```tree
		 * Sources $mol_link_source uri \https://github.com/Lyumih/gen
		 * ```
		 */
		@ $mol_mem
		Sources() {
			const obj = new this.$.$mol_link_source()
			
			obj.uri = () => "https://github.com/Lyumih/gen"
			
			return obj
		}
		
		/**
		 * ```tree
		 * User_page $gen_app_user user? <=> user?
		 * ```
		 */
		@ $mol_mem
		User_page() {
			const obj = new this.$.$gen_app_user()
			
			obj.user = (next?: any) => this.user(next)
			
			return obj
		}
		
		/**
		 * ```tree
		 * Pages $mol_book2_catalog
		 * 	menu_title \🧬
		 * 	param \page
		 * 	menu_filter_enabled false
		 * 	spreads * user_page <= User_page
		 * ```
		 */
		@ $mol_mem
		Pages() {
			const obj = new this.$.$mol_book2_catalog()
			
			obj.menu_title = () => "🧬"
			obj.param = () => "page"
			obj.menu_filter_enabled = () => false
			obj.spreads = () => ({
				user_page: this.User_page()
			} as Record< string, any >)
			
			return obj
		}
	}
	
}

